module.exports = __webpack_public_path__ + "img/f.9cce37b6.jpg";